import React, { Component } from 'react';
import TopMenu from './components/application/menu/TopMenu';
import ApplicationMenu from './components/application/menu/ApplicationMenu';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { openMenu, closeMenu, openSelectMenu, closeSelectMenu } from './actions/global';
import { openSearch } from './actions/events/search';
import { logOut } from './actions/authentication';
import { selectMenuOpenSelector, menuOpenSelector } from './selectors/application';
import { userEmailSelector, currentUserSelector } from './selectors/authentication';
import { selectedEventSelector, eventsOptionsSelector, selectedEventIdSelector } from './selectors/events/events';
import { isTimetable } from './selectors/router';
import { fetch } from './actions/events/select';
import {
    selectedPartnerNameSelector,
    filterSelectedPartnerSelector,
    filterPartnersSelector,
    viewFilterOpenSelector,
    filtersOpenSelector,
    hasFilterSelector,
    activityOpenSelector
} from './selectors/events/filter';
import { selectPartner, openViewFilter, toggleFiltersOpen, toggleActivityOpen } from './actions/events/filter';
import { searchOpenSelector } from './selectors/events/search';
import { showDotNotificationsSelector } from './selectors/events/timetable';

class ApplicationLayout extends Component {
    componentDidMount() {
        document.body.classList.remove('is-overflow-hidden');
        document.documentElement.classList.remove('is-overflow-hidden');
    }
    render() {
        return (
            <div className="ckp-layout">
                <TopMenu
                    showDot={this.props.showDot}
                    hasFilter={this.props.hasFilter}
                    toggleFiltersOpen={this.props.toggleFiltersOpen}
                    toggleActivityOpen={this.props.toggleActivityOpen}
                    filtersOpen={this.props.filtersOpen}
                    activityOpen={this.props.activityOpen}
                    openViewOptions={this.props.openViewFilter}
                    isViewFilterOpen={this.props.isViewFilterOpen}
                    selectPartner={this.props.selectPartner}
                    selectedPartnerName={this.props.selectedPartnerName}
                    partnerOptions={this.props.partnerOptions}
                    selectedPartner={this.props.selectedPartner}
                    user={this.props.currentUser}
                    events={this.props.events}
                    openMenu={this.props.openMenu}
                    title={this.props.selectedEvent && this.props.selectedEvent.name}
                    selectedEventId={this.props.selectedEvent && this.props.selectedEvent.id}
                    isTimetable={this.props.isTimetable}
                    openSearch={this.props.openSearch}
                    isSearchOpen={this.props.searchOpen}
                    logOut={this.props.logOut}
                />
                <ApplicationMenu
                    user={this.props.currentUser}
                    userEmail={this.props.userEmail}
                    events={this.props.events}
                    selectedEvent={this.props.selectedEvent}
                    selectedId={this.props.selectedEventId}
                    fetchEvents={this.props.fetch}
                    open={this.props.menuIsOpen}
                    closeMenu={this.props.closeMenu}
                    selectOpenMenu={this.props.openSelectMenu}
                    selectCloseMenu={this.props.closeSelectMenu}
                    selectIsOpen={this.props.selectMenuIsOpen}
                    logOut={this.props.logOut}
                />
                <div className="ckp-layout-main">{this.props.children}</div>
            </div>
        );
    }
}

const mapStateToProps = state => ({
    currentUser: currentUserSelector(state),
    isTimetable: isTimetable(state),
    selectedPartnerName: selectedPartnerNameSelector(state),
    partnerOptions: filterPartnersSelector(state),
    selectedPartner: filterSelectedPartnerSelector(state),
    menuIsOpen: menuOpenSelector(state),
    events: eventsOptionsSelector(state),
    userEmail: userEmailSelector(state),
    isViewFilterOpen: viewFilterOpenSelector(state),
    selectedEvent: selectedEventSelector(state),
    selectMenuIsOpen: selectMenuOpenSelector(state),
    showDot: showDotNotificationsSelector(state),
    selectedEventId: selectedEventIdSelector(state),
    hasFilter: hasFilterSelector(state),
    filtersOpen: filtersOpenSelector(state),
    activityOpen: activityOpenSelector(state),
    searchOpen: searchOpenSelector(state)
});

const mapDispatchToProps = dispatch =>
    bindActionCreators(
        {
            openMenu,
            closeMenu,
            logOut,
            openViewFilter,
            toggleFiltersOpen,
            toggleActivityOpen,
            fetch,
            selectPartner,
            openSelectMenu,
            closeSelectMenu,
            openSearch
        },
        dispatch
    );

export default connect(mapStateToProps, mapDispatchToProps)(ApplicationLayout);



// WEBPACK FOOTER //
// ./src/ApplicationLayout.js